/**
 * Keyboard shortcuts for the Formation Editor.
 * Subset of UseKeyboardShortcuts — only the tools relevant to formations.
 */

import { useEffect } from 'react'
import type { DrawingState } from '@/types'

interface FormationKeyboardShortcutHandlers {
	setDrawingState: (updates: Partial<DrawingState>) => void
	setShowColorPicker: (show: boolean) => void
}

export function useFormationKeyboardShortcuts({
	setDrawingState,
	setShowColorPicker,
}: FormationKeyboardShortcutHandlers): void {
	useEffect(() => {
		function handleKeyDown(event: KeyboardEvent) {
			// Ignore if user is typing in an input field
			if (event.target instanceof HTMLInputElement ||
				event.target instanceof HTMLTextAreaElement) {
				return
			}

			// Ignore modifier combos (no undo/redo in formations)
			if (event.metaKey || event.ctrlKey) return

			switch (event.key.toLowerCase()) {
				case 's':
					event.preventDefault()
					setDrawingState({ tool: 'select' })
					break
				case 'a':
					event.preventDefault()
					setDrawingState({ tool: 'addPlayer' })
					break
				case 'c':
					event.preventDefault()
					setShowColorPicker(true)
					break
				case 'f':
					event.preventDefault()
					setDrawingState({ tool: 'fill' })
					break
			}
		}

		document.addEventListener('keydown', handleKeyDown)
		return () => document.removeEventListener('keydown', handleKeyDown)
	}, [setDrawingState, setShowColorPicker])
}
